"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var state_1 = tslib_1.__importDefault(require("./state"));
var address_1 = tslib_1.__importDefault(require("./address"));
var agent_1 = tslib_1.__importDefault(require("./agent"));
var fee_1 = tslib_1.__importDefault(require("./fee"));
var feegroup_1 = tslib_1.__importDefault(require("./feegroup"));
var file_1 = tslib_1.__importDefault(require("./file"));
// @todo
// /employees/tin_lookup
// /employees/{pk}/sick_accrual
// /employees/{pk}/vacation_accrual
// /employees/{pk}/union_vacation_accrual
// /employees/{pk}/holiday_accrual
// /employees/{pk}/union_holiday_accrual
var EmployeeResource = /** @class */ (function (_super) {
    tslib_1.__extends(EmployeeResource, _super);
    function EmployeeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmployeeResource.endpoint = '/employees';
    EmployeeResource.MODEL_NAME = 'employee';
    EmployeeResource.related = {
        loanout_states_registered: state_1.default,
        address_residence: address_1.default,
        address_mailing: address_1.default,
        address_w2: address_1.default,
        agent: agent_1.default,
        fees: fee_1.default,
        fee_groups: feegroup_1.default,
        files: file_1.default
    };
    return EmployeeResource;
}(base_1.default));
exports.default = EmployeeResource;
//# sourceMappingURL=employee.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/employee.js
// module id = 47VE
// module chunks = 0